import React from "react";
import SecurityOutlinedIcon from "@mui/icons-material/SecurityOutlined";
import BoltOutlinedIcon from "@mui/icons-material/BoltOutlined";
import RocketLaunchOutlinedIcon from "@mui/icons-material/RocketLaunchOutlined";
import logo from "../assets/logo.jpeg";
import laptop from "../assets/laptop-cutout.png";

export function BrandMark() {
  return <div className="auth-brand" aria-label="Qylmox"><img className="brand-logo" src={logo} alt="Qylmox" /></div>;
}

const features = [
  [SecurityOutlinedIcon, "Secure & Safe", "Your data is encrypted and fully protected."],
  [BoltOutlinedIcon, "Fast & Reliable", "Lightning-fast performance you can count on."],
  [RocketLaunchOutlinedIcon, "Smart Solutions", "Innovations that simplify your business."],
];

export default function AuthShowcase({ signup = false }) {
  return <aside className="auth-showcase"><BrandMark /><div className="auth-copy"><h1>{signup ? <>Join the smarter<br />way to <span>manage fleets</span></> : <>Smart Solutions<br />for a <span>Better Tomorrow</span></>}</h1><div className="underline" /><p>Qylmox is dedicated to providing innovative, reliable and secure solutions to help your business grow and succeed.</p></div><div className="auth-features">{features.map(([Icon, title, text]) => <div className="auth-feature" key={title}><div className="feature-icon"><Icon /></div><div><strong>{title}</strong><small>{text}</small></div></div>)}</div><img className="laptop-art" src={laptop} alt="Qylmox fleet dashboard" /></aside>;
}
